import { getCompanyStyle } from "components/gql/gql-functions";
import { GetCompanyExtensionDataQuery } from "components/gql/queris/GetCompanyExtData";
import {
  isIdentical,
  isObjectEmpty,
  isValidToken,
  validArray,
} from "data/functions";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAlertStore from "./store/use-alert-store";
import useAppStore from "./store/use-app-store";

// App.js
function AppInitializer() {
  const { companyUuid, token } = useAppStore();
  const searchParameters = new URLSearchParams(window.location.search);
  const { alertArray } = useAlertStore();
  const [getCompanyExtensionDataQuery] = GetCompanyExtensionDataQuery();

  useEffect(() => {
    if (!isObjectEmpty(alertArray)) {
      const interval = setInterval(() => {
        for (let index = 0; index < validArray(alertArray).length; index++) {
          const element = validArray(alertArray)[index];
          let now = Date.now();
          let alertExpired = element?.timestamp || now + 3 * 1000;
          if (now >= alertExpired) {
            useAlertStore.setState((state) => ({
              alertArray: validArray(state.alertArray).filter(
                (v) => v?.id !== element?.id,
              ),
            }));
          }
        }
      }, 1000);

      return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }
  }, [alertArray]);

  useEffect(() => {
    if (companyUuid && isValidToken(token)) {
      getCompanyStyle(getCompanyExtensionDataQuery);
    }
  }, [companyUuid, token]);

  React.useEffect(() => {
    const { message: exist } = useAppStore.getState();
    let text = searchParameters.get("text");
    let dataUuid = searchParameters.get("data_uuid");
    let signDataUuid = searchParameters.get("sign_data_uuid");
    let signatureType = searchParameters.get("signature_type");
    let companyUuid = searchParameters.get("company_uuid");
    let createdAt = searchParameters.get("created_at");

    let message = {
      company_uuid: companyUuid || "",
      created_at: createdAt,
      data_uuid: dataUuid || "",
      date: "",
      sign_data_uuid: signDataUuid || "",
      signature_type: signatureType || "attached",
      text: text || "",
    };

    if (!isObjectEmpty(createdAt)) {
      try {
        let date = new Date(createdAt);
        date.setMinutes(date.getMinutes() + 1);
        message.date = date.toISOString();
      } catch (error) {
        message.date = "";
      }
    }

    if (!isIdentical(message, exist)) {
      useAppStore.setState({ message });
    }
  }, []);
}

export default AppInitializer;
